import { API } from 'aws-amplify'

export const ErrorLogging = () => {
  const logErrorBoundaryError = async (err: Object) => {
    return API.post('client', '/client-logging/error-boundary', { body: err })
  }
  return { logErrorBoundaryError }
}
